import { Card } from '@etg/wings';
import { DangerousHtmlContent, Overlay } from '@eti/components';
import { css } from '@eti/styles';

export interface RyanairVerificationProcessOverlayProps {
  isOpen: boolean;
  onClose: () => void;
  ryanairVerificationProcessDescription: string;
  ryanairVerificationProcessHeaderText: string;
}

const drawerInnerstyles = css`
  ul {
    list-style: disc;
    margin: 20px 0;
    padding-left: 24px;

    li {
      margin-bottom: 10px;
    }
  }
`;

const RyanairVerificationProcessOverlay = ({
  isOpen,
  onClose,
  ryanairVerificationProcessDescription,
  ryanairVerificationProcessHeaderText,
}: RyanairVerificationProcessOverlayProps) => (
  <Overlay.Drawer
    dataTestId="ryanairVerificationProcess-overlay"
    handleClose={onClose}
    isOpen={isOpen}
  >
    <Overlay.Header onClose={onClose} title={ryanairVerificationProcessHeaderText} />
    <Overlay.Content data-testid="ryanairVerificationProcess-overlay-content">
      <Card>
        <DangerousHtmlContent
          className={drawerInnerstyles}
          content={ryanairVerificationProcessDescription}
        />
      </Card>
    </Overlay.Content>
  </Overlay.Drawer>
);

export default RyanairVerificationProcessOverlay;
